// Чистые функции/выражения, строящие стили MapLibre из примитивных входов -
// вынесены из MapView.vue (см. пояснение в constants.ts этой же папки).

// LOD: слой, который просто включается на своём `minzoom` - невидим на
// z13.99, полностью непрозрачен на z14.00 - читается как хлопок, а не
// проявление, в момент пересечения этой границы при пане/зуме, и это визуальный
// шум даже когда сам контент точно правильный. Поэтому каждый слой с жёстким
// minzoom плавно появляется на протяжении примерно одного уровня зума, как
// уже было у contours-line и landcover-ground-outline.
export const fadeInFrom = (minzoom: number, target: number): any => [
  "interpolate",
  ["linear"],
  ["zoom"],
  minzoom, 0,
  minzoom + 1, target,
];

// Ширина несёт второй, более грубый сигнал вместе с цветом: насколько это
// «настоящая» тропа. `footway` и `steps` тоньше `path`/`bridleway` в основном
// из-за того, что footway означает в городе - каждый тротуар Алматы это он,
// и на z10-12 они иначе сливаются в сплошное красно-коричневое пятно над
// городом, забивающее горные тропы. Утончение оставляет данные на карте, не
// давая им доминировать. (Отличить тротуар от лесной тропы нечем - подтег
// footway=sidewalk не входит в экспортируемые tile-функциями колонки, так
// что это намеренно грубый инструмент.)
export const trailWidthAt = (path: number, footway: number): any => [
  "match",
  ["get", "highway"],
  ["footway", "steps"], footway,
  path,
];

// Один пунктир для всех троп - частый и тесный, читается на фоне густых изолиний.
export const TRAIL_DASH: any = ["literal", [1, 1.3]];

export const waterwayWidthAt = (river: number, stream: number): any => [
  "match",
  ["get", "waterway"],
  "river", river,
  stream,
];

// `hidden` появляется на объектах POIS_CLUSTER_SOURCE только когда editMode
// их заполнил (refreshPoiClusterSource) - для не-редактора его просто нет,
// так что `case` ниже мёртвый груз, не живая проверка (та же
// ничего-не-стоящая-когда-не-нужна форма, что и у editIconOpacity в
// basemapLayers.ts для pois-peak-admin). Затухания по зуму больше нет -
// `minzoom` слоя, который это выражение красит, теперь и есть LOD-порог,
// жёсткий вкл/выкл, а это выражение делает только то, что и раньше делала
// конечная точка рампы: гасит скрытый POI в режиме редактирования.
export const clusterHiddenOpacity: any = ["case", ["==", ["get", "hidden"], true], 0.4, 1];

// ── Contours (изолинии) ───────────────────────────────────────────────────
// Цвета изолиний OpenTopoMap. `#c45700` - линия, `#bc7e55` - подпись высоты,
// намеренно светлее линии, чтобы число не перекрикивало форму рельефа.
export const CONTOUR_COLOR = "#c45700";
export const CONTOUR_LABEL_COLOR = "#bc7e55";

// Опорные изолинии: каждые 100 м, рисуются жирнее и единственные подписываются,
// как на печатной топокарте. Tile-функция отдаёт только `elevation_m`
// (Alembic 20260825_03) специально для того, чтобы это оставалось клиентским
// выражением - какой интервал подаётся на данном зуме, решает сервер, а
// какая из линий опорная - решает стиль.
export const CONTOUR_IS_INDEX: any = ["==", ["%", ["get", "elevation_m"], 100], 0];
